export default __webpack_public_path__ + "static/media/gold.c05af876.png";